import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EmptyData } from "../../../../components/empty/emptyData";
import { AddMtsModal } from "./AddMts";
import { useMtsOrganizations } from "./useMts";
import { FilterPersonel } from "./FilterMts";
import { EntMtsFilter } from "../../../../models/filters/mtsFilter";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import { EntMts } from "../../../../models/mts";
import { useLazyGetMtsListAllQuery } from "../../../../redux/api/mechanization/mtsOrganizationsApi";
import { useGetReportByMtsMutation } from "../../../../redux/api/mechanization/reportDepartmentMechApi";
import ReportDepartmentMechModal from "../reportDepartmentMech/ReportDepartmentMechModal";

enum FormField {
  name,
}

export const Mts = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntMts>(new EntMts());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getMtsReport] = useGetReportByMtsMutation();
  const [getArchiveFolders] = useLazyGetMtsListAllQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntMts, EntMtsFilter>({
	initialFilter: new EntMtsFilter(),
	query: getArchiveFolders
  });

  const { onAddMts, onEditMts, onDeleteMts } = useMtsOrganizations(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isMechAvailable = storedData.some((route: any) => (route.alias === "/departments/mechanization/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntMts) => {
	setSelectedItem(item);
	setShowModal(true);
  }
  const setEntityFromFields = (): EntMtsFilter => {
	let filt: EntMtsFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const getReport = async (payload: { years?: number[]; languageEnum: string }): Promise<Blob> => {
	return await getMtsReport(payload).unwrap();
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('mts.name_organizations') }</th>

		  <th>{ t('mts.forms_of_ownership') }</th>
		  <th>{ t('mts.supervisor_name') }</th>
		  <th>{ t('mts.contact_phone_number') }</th>
		  <th>{ t('mts.contact_email_address') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ i18n.language === 'ru' ? item?.nameRu : item?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item?.ownershipForm?.nameRu : item?.ownershipForm?.nameKy }</td>
			<td>{ item.managerFullName } </td>
			<td>{ item.phone } </td>
			<td>{ item.email } </td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteMts(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : <tr>
		  <td colSpan={ 7 }>
			<EmptyData/>
		  </td>

		</tr> }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('mts.mts_organizations') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('mts.mts_organizations_desc') } { t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntMts())
		} }>
		  { t('mts.add_mts_organizations') }
		</Button>
	  ) }
	  { isMechAvailable && (
		<Button style={ { marginLeft: '5px' } } type="primary" icon={ <PlusOutlined/> }
				onClick={ () => setShowReportModal(true) }>
		  { t('general.generate_report') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterPersonel onSearch={ searchHandleClick }
								 onReset={ () => {
								   clearFields();
								   searchHandleClick()
								 } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddMtsModal
		mts={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		  setSelectedItem(new EntMts());
		} }
		onSubmit={ selectedItem.id !== null ? onEditMts : onAddMts }
	  />
	  <ReportDepartmentMechModal
		type={ 'mts' }
		title={ t('reports.report_by_mts') }
		getReport={ getReport }

		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
	  { contextHolder }
	</>
  )
}
